import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CashBoxClosedPage } from './cash-box-closed.page';

const routes: Routes = [
  { path: '', redirectTo: 'closed', pathMatch: 'full' },
  { path: 'closed', component: CashBoxClosedPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CashBoxRoutingModule { }
